import { render, staticRenderFns } from "./navigation-bar.vue?vue&type=template&id=224f384e&"
import script from "./navigation-bar.vue?vue&type=script&lang=ts&"
export * from "./navigation-bar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports